import React, { useState, useEffect } from "react";
import "react-table-v6/react-table.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Row, Col } from "reactstrap";

import ReactTable from "react-table-v6";
import {
  API_URL,
  getApiConfig,
  getUserRoleId,
  token,
} from "../../Config/apiConfig.js";
// import {
//   OLD_API_URL,
//   oldGetApiConfig,
//   oldToken,
// } from "../../Config/oldApiConfig.js";
import customFilterMethod from "helpers/customFilterMethod.js";
import statusFilterMethod from "helpers/statusFilterMethod.js";

export default function AdminTabInfo() {
  const nav = useNavigate();
  const [boitierList, setBoitierList] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const userRoleId = getUserRoleId();
  const localization = {
    previousText: "Précédent",
    nextText: "Suivant",
    pageText: "Page",
    ofText: "sur",
    rowsText: "lignes",
  };

  const onRowClick = (rowInfo) => {
    // const isOld = rowInfo.noSerie >= 0 && rowInfo.noSerie <= 3500;
    nav(`/showBoitier/${rowInfo.id}`);
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  useEffect(() => {
    axios
      .get(API_URL + "showAllBoitierList", getApiConfig())
      .then((res) => {
        console.log("Liste des boîtiers:", res.data);
        if (Array.isArray(res.data)) {
          setBoitierList(res.data);
        } else if (Array.isArray(res.data.data)) {
          setBoitierList(res.data.data);
        } else {
          setBoitierList([]);
        }
      })
      .catch((err) => {
        console.error("Erreur lors de la récupération des boîtiers:", err);
        setBoitierList([]);
      });
  }, []);

  // useEffect(() => {
  //   if (oldToken) {
  //     axios
  //       .get(OLD_API_URL + "boitieradmin", oldGetApiConfig())
  //       .then((res) => {
  //         const ancienneData = res.data.data;
  //         ancienneData.forEach((boitier) => {
  //           boitier.statut =
  //             boitier.statut === true || boitier.statut === "actif"
  //               ? "actif"
  //               : "inactif";
  //           boitier.actif =
  //             boitier.actif === true || boitier.actif === "actif"
  //               ? "actif"
  //               : "inactif";
  //           boitier.diagnostic =
  //             boitier.diagnostic || boitier.diagnostic === "actif"
  //               ? "actif"
  //               : "inactif";
  //         });
  //         console.log("Ancienne API:", ancienneData);
  //         if (Array.isArray(ancienneData)) {
  //           setBoitierList((prevList) => [...prevList, ...ancienneData]);
  //         } else {
  //           console.error(
  //             "Les données de l'ancienne API ne sont pas un tableau :",
  //             ancienneData
  //           );
  //         }
  //       })
  //       .catch((err) => {
  //         console.error(
  //           "Une erreur s'est produite lors de la récupération des données de l'API ancienne:",
  //           err
  //         );
  //       });
  //   }
  // }, []);

  const ESSENTIAL_COLUMNS = [
    'id',
    'noSerie',
    'versionSoftware',
    'state',
    'boitier_version',
    'user_id',
    'mail_alerte'
  ];

  const getEssentialColumns = (allColumns) => {
    return allColumns.filter(col => {
      const identifier = col.id || col.accessor || '';
      const identifierStr = typeof identifier === 'string' ? identifier.toLowerCase() : '';
      
      const accessorStr = typeof col.accessor === 'string' ? col.accessor : '';
      
      return (
        ESSENTIAL_COLUMNS.includes(accessorStr) ||
        identifierStr.includes('sim')
      );
    });
  };

  const allColumns = [
    { Header: "ID", accessor: "id" },
    { Header: "Numéro de série", accessor: "noSerie" },
    { Header: "Date d'activation", accessor: "dateActivation", Cell: ({ value }) => value ? formatDate(value) : "" },
    { Header: "Première connexion", accessor: "firstConnect", Cell: ({ value }) => value ? formatDate(value) : "" },
    { Header: "Dernière mise à jour", accessor: "lastUpdate", Cell: ({ value }) => value ? formatDate(value) : "" },
    { Header: "Dernier déplacement", accessor: "lastMoved", Cell: ({ value }) => value ? formatDate(value) : "" },
    { Header: "Limite temps connexion", accessor: "ConnectionTimeLimit" },
    { Header: "Version logicielle", accessor: "versionSoftware" },
    { Header: "Version visible", accessor: "versionVisible" },
    { Header: "Langue", accessor: "language" },
    { Header: "Commentaire", accessor: "comment" },
    { Header: "État", accessor: "state", Cell: ({ value }) => value ? "Actif" : "Inactif" },
    { Header: "Ouvert", accessor: "isOpen", Cell: ({ value }) => value ? "Oui" : "Non" },
    { Header: "Module pH", accessor: "phModule", Cell: ({ value }) => value ? "Oui" : "Non" },
    { Header: "GSM", accessor: "hasGsm", Cell: ({ value }) => value ? "Oui" : "Non" },
    { Header: "Mode Boost", accessor: "modeBoost", Cell: ({ value }) => value ? "Oui" : "Non" },
    { Header: "État bobine A", accessor: "coilStateA", Cell: ({ value }) => value ? "On" : "Off" },
    { Header: "État bobine B", accessor: "coilStateB", Cell: ({ value }) => value ? "On" : "Off" },
    { Header: "État générateur A", accessor: "generatorStateA", Cell: ({ value }) => value ? "On" : "Off" },
    { Header: "État générateur B", accessor: "generatorStateB", Cell: ({ value }) => value ? "On" : "Off" },
    { Header: "Depuis connexion", accessor: "since_connect", Cell: ({ value }) => value ? formatDate(value) : "" },
    { Header: "Moyen co", accessor: "moyen_co" },
    { Header: "Latitude", accessor: "markerLat" },
    { Header: "Longitude", accessor: "markerLng" },
    { Header: "Nom client", accessor: "customerName" },
    { Header: "Adresse", accessor: "address" },
    { Header: "Code postal", accessor: "postcode" },
    { Header: "Ville", accessor: "city" },
    { Header: "Pays", accessor: "country" },
    { Header: "Version boîtier", accessor: "boitier_version" },
    { Header: "Créé le", accessor: "created_at", Cell: ({ value }) => value ? formatDate(value) : "" },
    { Header: "Modifié le", accessor: "updated_at", Cell: ({ value }) => value ? formatDate(value) : "" },
    { Header: "User ID", accessor: "user_id" },
    { Header: "Mail alerte", accessor: "mail_alerte" },
    {
      Header: "SIM ICCID",
      accessor: (row) => row?.sim?.iccid ?? "",
      id: "simIccid",
    },
    {
      Header: "SIM PIN",
      accessor: (row) => row?.sim?.pin ?? "",
      id: "simPin",
    },
    {
      Header: "SIM Lot",
      accessor: (row) => row?.sim?.lot ?? "",
      id: "simLot",
    },
    {
      Header: "SIM V3 ICCID",
      accessor: (row) => row?.simv3?.iccid ?? "",
      id: "simv3Iccid",
    },
    {
      Header: "SIM V3 PIN",
      accessor: (row) => row?.simv3?.pin ?? "",
      id: "simv3Pin",
    },
    {
      Header: "SIM V3 Lot",
      accessor: (row) => row?.simv3?.lot ?? "",
      id: "simv3Lot",
    },
  ];

  const columns = isExpanded ? allColumns : getEssentialColumns(allColumns);

  console.log("Données des boîtiers:", boitierList);

  return (
    <>
      <Row className="CenterAll">
        <Col lg="12">
          <Card className="mt-5">
            <div className="card-header d-flex justify-content-between align-items-center">
              <button 
                className="btn btn-sm btn-primary" 
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {isExpanded ? 'Masquer' : 'Afficher tout'}
              </button>
            </div>
            <div>
              <Col lg="12">
                <Card>
                  <CardBody>
                    {" "}
                    <ReactTable
                      filterable
                      defaultFilterMethod={customFilterMethod}
                      data={boitierList}
                      columns={columns}
                      defaultPageSize={10}
                      previousText={localization.previousText}
                      nextText={localization.nextText}
                      pageText={localization.pageText}
                      ofText={localization.ofText}
                      rowsText={localization.rowsText}
                      getTrProps={(state, rowInfo) => ({
                        onClick: () => onRowClick(rowInfo.original),
                      })}
                    />
                  </CardBody>
                </Card>
              </Col>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
}
